import { paths } from 'src/routes/paths';
import type { ServiceNamespace } from 'src/locales/langs';

export type ServicePageConfig = {
  path: string;
  namespace: ServiceNamespace;
  secondaryCtaPath: string;
};

export const servicePages: ServicePageConfig[] = [
  {
    path: paths.services.agents,
    namespace: 'service-agents',
    secondaryCtaPath: paths.services.secureAi,
  },
  {
    path: paths.services.tools,
    namespace: 'service-tools',
    secondaryCtaPath: paths.services.implementations,
  },
  {
    path: paths.services.implementations,
    namespace: 'service-implementations',
    secondaryCtaPath: paths.services.migrations,
  },
  {
    path: paths.services.migrations,
    namespace: 'service-migrations',
    secondaryCtaPath: paths.services.secureAi,
  },
  {
    path: paths.services.secureAi,
    namespace: 'service-secure-ai',
    secondaryCtaPath: paths.services.agents,
  },
];
